module.exports = __webpack_public_path__ + "img/search-user.b82bf80d.png";